//
//
//
//
//
//

import { go } from '../../libs/router'

export default {
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClick () {
      this.link && go(this.link, this.$router)
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/cell-box/index.vue